import script from "./addSensitive.vue?vue&type=script&setup=true&lang=js"
export * from "./addSensitive.vue?vue&type=script&setup=true&lang=js"

import "./addSensitive.vue?vue&type=style&index=0&id=21bc94b6&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21bc94b6"]])

export default __exports__